import { Component, computed, inject, OnInit, signal } from '@angular/core';

import { UiFormFieldBuilderModule } from '@digipay/ui-form-field-builder';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { JalaliDatePipe } from '@digipay/ng-lib-pipes';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { ActivatedRoute } from '@angular/router';
import { WalletService } from '../../services/wallet.service';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { WALLETS_ROUTE } from '../../../../data-access/constants/app-routes';
import { BaseComponent } from '../../../../components/core/components/base/base.component';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { IProcessData } from '../../models/wallet-process.interface';
import { IWalletProcess } from '../../models/wallet-cashin-model.interface';
import { WALLET_BNPL_PROCESS_API } from '../../../../data-access/constants/api';
import moment from 'jalali-moment';
import { convertTimestampToDate } from '../../../../components/utils/strings';

@Component({
  selector: 'wealth-applet-wallet-bnpl',
  standalone: true,
  imports: [NgxAppBarComponent, UiFormFieldBuilderModule, ReactiveFormsModule, NgxButtonComponent],
  templateUrl: './wallet-bnpl.component.html',
  styleUrl: './wallet-bnpl.component.scss',
})
export class WalletBnplComponent extends BaseComponent implements OnInit {
  birthDayController: FormControl = new FormControl();
  navigationService = inject(WealthNavigationService);
  pipesModule = new JalaliDatePipe();

  isLoading = signal<boolean>(false);
  walletId = signal<string | undefined>(undefined);
  serverErrorMessage = signal<string | undefined>(undefined);
  state = signal<IProcessData | undefined>(undefined);
  minBirthDate = moment().subtract('70', 'year').valueOf();
  maxBirthDate = moment().subtract('15', 'year').valueOf();
  customDateRange = computed<[number, number] | undefined>(() => {
    return [this.minBirthDate, this.maxBirthDate];
  });
  private routeState = inject(RouteStateService);
  private walletService = inject(WalletService);
  private activatedRoute = inject(ActivatedRoute);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.walletId.set(this.activatedRoute.snapshot.params['id']);
    this.state.set(this.routeState.getAll());
    if (!this.state()?.walletName) {
      this.navigationService.navigate([WALLETS_ROUTE, this.walletId()]);
    }
    this.birthDayController.setValidators([Validators.required]);
  }

  onBackHandler() {
    this.navigationService.navigate([WALLETS_ROUTE, this.walletId()]);
  }

  continue() {
    this.isLoading.set(true);
    const processData: IWalletProcess = {
      walletName: this.state().walletName,
      birthDate: this.pipesModule.transform(convertTimestampToDate(this.birthDayController?.value)),
      walletId: this.walletId(),
    };
    this.walletService.walletProcess(WALLET_BNPL_PROCESS_API, processData).subscribe((res) => {
      if (res.success) {
        if (res && res.result && res.result.action === 'error') {
          this.birthDayController.setErrors({ invalidBirthDay: true });
          this.serverErrorMessage.set(res.result.data.message);
        }
      }
      this.isLoading.set(false);
    });
  }
}
